import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { MsalService } from '@azure/msal-angular';
import { jwtDecode } from 'jwt-decode';
import { Router } from '@angular/router';
import { EncryptDecryptService } from './encrypt-decrypt.service';
import { BehaviorSubject } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import {  ConfirmationService } from 'primeng/api';
import { Constants, appConfig } from '../models/constants';
@Injectable({ providedIn: 'root' })
export class StorageService {
    isAdmin: boolean = false;
    isFunctional: boolean = false;
    isHomeAllowed: boolean = false;
    isTaxAdjustmentAdmin: boolean = false;
    isCoaAdminSelected: boolean = false;
    retryCount: number = 0;
    retry: boolean = false;
    private readonly cookieStorageKeys: string[];
    concurrFound = new BehaviorSubject(false);
    concurrFound$ = this.concurrFound.asObservable();
    constructor(
        private readonly cookieService: CookieService,
        private authService: MsalService,
        private msalService: MsalService,
        private router: Router,
        private encryptDecryptService: EncryptDecryptService,
        private httpClient: HttpClient,
        private confirmationService: ConfirmationService,


    ) {
        this.cookieStorageKeys = ['TOKEN'];
    }

    setTokenInBackend() {
        this.httpClient.get(Constants.GATEWAY_BASE_API_URL + '/refresh/token', {
            responseType: 'json'
        }).subscribe((response) => { });
    }

    setCookies(idToken:any, key='msal.idtoken') {
        let time = this.createTokenForOneHour();
        this.cookieService.set(key, idToken, time, '/', undefined, false, 'Strict');
        this.cookieService.set(key, idToken, time, '/', undefined, true, 'None');
    }

    setSessionStorage(key, value) {
       
        sessionStorage.setItem(key, value);
    }

    getSessionStorage(key) {
      
        return sessionStorage.getItem(key);
    }

    getCookie(key) {
        return this.cookieService.get(key);
    }
    
    clearAll(): void {
        localStorage.clear();
        sessionStorage.clear();
        this.cookieService.deleteAll();
    }

    unAuthUserFound() {
        this.clearAll();
        this.msalService.logoutRedirect().subscribe();
    }

    logOut(concurrent: boolean) {
        this.httpClient.get(Constants.GATEWAY_BASE_API_URL + '/logout/' + concurrent, { responseType: 'json'}).subscribe(() => { });
        if(!concurrent) 
            this.clearAll();
        this.msalService.logoutRedirect().subscribe();
    }

    public get(key: string): string {
        //encrypt added
        if (!key) {
            return 'undefined';
        }
        key = key.includes('Global_') ? key.replace('Global_', '') : key;
        const encValue = sessionStorage.getItem('Global_' + key);
        if (!encValue) {
            return 'undefined';
        }
        const decVal = this.encryptDecryptService.decrypt(encValue);
        return decVal;
    }

    public set(key: string, value: string) {
        let time = this.createTokenForOneHour();
        //new code with encrypt
        if (!key || !value) {
            return;
        }
        const encValue = this.encryptDecryptService.encrypt(value);

        sessionStorage.setItem('Global_' + key, encValue);
    }

    public removeItem(key: string) {
        key = key.includes('Global_') ? key.replace('Global_', '') : key;
        const encKey = this.encryptDecryptService.encrypt(key);
        this.cookieService.delete(encKey);
    }

    clearTokenfromLocal() {
        let localData = { ...localStorage };
        for (const property in localData) {
            if (property.includes('msal') || property.includes('{')) {
                localStorage.removeItem(property);
            }
        }
        //this.refreshTokenTimer();
    }

    refreshTokenTimer() {
        const scopes = ['user.read', 'openid', 'Mail.Send'];
        const renewIdTokenRequest = {
            clientId:appConfig.appConfigService.azureAdConfig.clientId,
            scopes: scopes,
            // forceRefresh: true
        };
        const jwtToken = JSON.parse(atob(this.getSessionStorage('msal.idtoken').split('.')[1]));
        const expires = new Date(jwtToken.exp * 1000);
        // const timeout = expires.getTime() - Date.now() - 5 * 60 * 1000;   //1800000
        const userName = this.authService?.instance?.getActiveAccount()?.username || '';
        //setTimeout(() => this.renewToken(renewIdTokenRequest), 1800000);
    }

    renewToken(renewIdTokenRequest: any) {
        this.authService.acquireTokenPopup(renewIdTokenRequest).subscribe({
            next: (response: any) => {
                let token = localStorage.getItem('msal.idtoken');
                this.setCookies(token);
                this.retry = true;
            },
            error: (error: any) => {
                if (error.message.includes('popups')) {
                    this.confirmationService.confirm({
                        message:
                            'Please always allow popups from DigiCorporateTax portal for continuing your work without getting logged out. This setting is usually available under Privacy and security section in browser settings.',
                        acceptLabel: 'Ok',
                        rejectVisible: false,
                        accept: () => {
                            this.confirmationService.close();
                        },
                    });
                }
                setTimeout(() => {
                    this.authService.acquireTokenPopup(renewIdTokenRequest).subscribe({
                        next: (response: any) => {
                            let token = localStorage.getItem('msal.idtoken');
                            this.setCookies(token);
                        },
                        error: (error: any) => {
                            this.errorFoundInToken();
                        }
                    })
                }, 10000);
            }
        });
    }

    errorFoundInToken() {
        if (
            ((!localStorage.getItem('msal.idtoken') || !this.get('msal.idtoken') || this.getSessionStorage('msal.idtoken')) &&
                !this.tokenValidateTime) ||
            this.retryCount > 10
        ) {
            this.unAuthUserFound();
        } else {
            const renewIdTokenRequest = {
                clientId: appConfig.appConfigService.azureAdConfig.clientId,
                scopes: ['openid'],
                forceRefresh: true,
            };
            this.renewToken(renewIdTokenRequest);
        }
        this.retryCount++;
    }

    rewnalCookiesTime() {
        let cookiesData = this.cookieService.getAll();
        for (const property in cookiesData) {
            if (property.includes('Global_')) {
                this.cookieService.delete(property);
                this.set(property, cookiesData[property]);
            }
        }
    }

    createTokenForOneHour() {
        return new Date(Date.now() + 5*60*60 * 1000);
    }

    getUserName() {
        const name = this.authService?.instance?.getActiveAccount()?.name;
        return (name?.length > 0 ? name : this.deCodeJWT('name')) || '';
    }

    getUserEmail() {
        const username = this.authService?.instance?.getActiveAccount()?.username; 
        return (
            (username?.length > 0 ? username.toLowerCase() : this.deCodeJWT('preferred_username')) || ''
        )
    }

    deCodeJWT(key:any) {
        const token = this.getSessionStorage('msal.idtoken');
        const decoded = jwtDecode(token);
        return decoded [key];
    }

    tokenValidateTime() {
        return (new Date().getTime() <= Number(this.cookieService.get('msal.idTokenExpiry')));
        // const jwtToken = this.cookieService.get('msal.idtoken');
        // if (!jwtToken) {
        //     return false;
        // }
        // const parsedToken = JSON.parse(atob(jwtToken.split('.')[1]));
        // console.log(parsedToken);
        // return Date.now() <= parsedToken.exp * 1000;
    }

    private privacy = new BehaviorSubject(false);
    privacyAccepted = this.privacy.asObservable();

    changePrivacy(value: any) {
        this.privacy.next(value);
    }

    public setWithDefaultPassphrase(key: string, value: string) {
        let time = this.createTokenForOneHour();
        //new code with encrypt
        if (!key || !value) {
            return;
        }
        const encValue = this.encryptDecryptService.encryptWithDefault(value);
        sessionStorage.setItem('Global_' + key, encValue);
    }

    public getWithDefaultPassphrase(key: string): string {
        //encrypt added
        if (!key) {
            return 'undefined';
        }
        key = key.includes('Global_') ? key.replace('Global_', '') : key;
        const encValue = sessionStorage.getItem('Global_' + key);
        if (encValue) {
            return 'undefined';
        }
        const decVal = this.encryptDecryptService.decryptWithDefault(encValue);
        return decVal;
    }

    public encodeValue(key: string, value: string) {
        let time = this.createTokenForOneHour();
        let encoded = this.encryptDecryptService.encode(value);
        sessionStorage.setItem('Global_' + key, encoded);
    }

    public decodeValue(key: string) {
        if (!key) {
            return 'undefined';
        }
        key = key.includes('Global_') ? key.replace('Global_', '') : key;
        const encValue = sessionStorage.getItem('Global_' + key);
        if (!encValue) {
            return 'undefined';
        }
        const decVal = this.encryptDecryptService.decode(encValue);
        return decVal;
    }

     endPreviousSession(){
        this.httpClient.get(Constants.GATEWAY_BASE_API_URL + '/endPreSession', { responseType: 'json' }).subscribe(() => { });
     }
}
